import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default function ProPlayer({ course, session, BeURL }) {

    const videoRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {

        if (!session || !course) return;

        const videoSrc =
            `${BeURL}/course/${course._id}/syllabus/${session.syllabusId}/session/${session._id}/stream`;

        console.log("LOAD VIDEO:", videoSrc);

        /* ================= FIRST TIME INIT ================= */

        if (!playerRef.current) {

            playerRef.current = videojs(videoRef.current, {
                controls: true,
                fluid: true,
                preload: "auto",
                sources: [{
                    src: videoSrc,
                    type: "video/mp4"
                }]
            });

        } else {

            /* ================= CHANGE VIDEO SOURCE ================= */

            playerRef.current.pause();      
            playerRef.current.src({
                src: videoSrc,
                type: "video/mp4"
            });

            playerRef.current.load();
            playerRef.current.currentTime(0);  
            playerRef.current.play();        
        }

       

        return () => { };

    }, [session?._id , BeURL , session , course]); 

    return (
        <div className="w-full h-full rounded-xl">
            <video
                ref={videoRef}
                className="video-js vjs-big-play-centered rounded-xl"
            />
        </div>
    );
}

